export default "__VITE_ASSET__09uJpTLy__"